window.BridgeApi = {};
class ClientApi {
  constructor() {
    this.clientType = this.getMobileOperatingSystem();
  }

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  }

  async setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement("iframe");
    WVJBIframe.style.display = "none";
    WVJBIframe.src = "https://__bridge_loaded__";
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }

  // 注册方法供app调用
  registerBridgeApi(name, fn) {
    if (this.clientType === "iOS") {
      this.setupWebViewJavascriptBridge(function(bridge) {
        bridge.registerHandler(name, fn);
      });
    } else if (this.clientType === "Android") {
      window.BridgeApi[name] = fn;
    }
  }

  checkApi(type) {
    if (this.clientType === "iOS") {
      return this.checkIOSApi(type);
    }
    if (this.clientType === "Android") {
      return this.checkAndroidApi(type);
    }
  }

  async getApi(type, ...param) {
    type === "setTitleJS" && (document.title = param); // 解决title

    if (this.clientType === "iOS") {
      try {
        let data = await this.getIOSApi(type, param);
        return data;
      } catch (e) {
        throw new Error(e);
      }
    }
    if (this.clientType === "Android") {
      let data = await this.getAndroidApi(type, param);
      return data;
    }
  }
  checkIOSApi(type) {
    let that = this;
    let timeout;
    return new Promise(function(resolve) {
      timeout = setTimeout(() => {
        resolve(false);
      }, 5000);

      that.setupWebViewJavascriptBridge(function(bridge) {
        bridge.callHandler("checkRegisterHandler", type, function(data) {
          clearTimeout(timeout);
          resolve(!!data);
        });
      });
    });
  }
  getIOSApi(type, param) {
    let that = this;
    console.log("type, param", type, param);
    // let timeout = false
    return new Promise(function(resolve) {
      // let status = true
      that.setupWebViewJavascriptBridge(function(bridge) {
        // status = false
        if (param.length > 1) {
          bridge.callHandler(type, param, function(data) {
            console.log("data1", data);
            resolve(data);
          });
        } else {
          bridge.callHandler(type, ...param, function(data) {
            console.log("data2", data);
            resolve(data);
          });
        }
      });
    });
  }
  checkAndroidApi(type) {
    return new Promise(function(resolve) {
      if (!window.MiDriveAppJs || !window.MiDriveAppJs[type]) {
        resolve(false);
      }
      typeof window.MiDriveAppJs[type] !== "function"
        ? resolve(false)
        : resolve(true);
    });
  }
  async getAndroidApi(type, param) {
    try {
      if (!window.MiDriveAppJs || !window.MiDriveAppJs[type]) {
        return false;
      }
      return window.MiDriveAppJs[type](...param);
    } catch (e) {
      throw new Error(e);
    }
  }

  async getPromiseAll(arr) {
    if (!Array.isArray(arr) || arr.length <= 0) {
      return false;
    }

    let all = [];

    arr.forEach(item => {
      all.push(this.getApi(item));
    });

    return Promise.all(all);
  }
}

export default new ClientApi();
